import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { GroupsGridDataService } from 'common/services/data-services/admin/groups/groups-grid-data.service';
import { GroupsListingModel } from 'common/models/page-models/groups/groups-grid-model';
import { GroupsModel } from 'common/models/page-models/groups/groups-model';
import { GroupsGridMetaModel } from 'common/models/page-models/groups/groups-grid-meta-model';



@Injectable({
    providedIn: 'root'
})
export class GroupsGridWidgetService extends GridWidgetService<GroupsModel, GroupsListingModel> {
    constructor(protected override ds: GroupsGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new GroupsGridMetaModel().getMetaModel();
        return meta;
    }
}